<template>
  <v-container grid-list-md>
    <v-layout row wrap class="btn-wrapper">
      <v-btn class="btn-primary" @click="openEditDialog">
        <img src="static/icons/create_white.png" width="26" />Edit
      </v-btn>

      <v-dialog
        v-model="dialog"
        @keydown.esc="dialog = false"
        persistent
        scrollable
      >

        <v-card style="width: 100vw;">
          <v-card-title>
            <v-flex xs12>
              <p class="headline">{{ $t('message.tabHeader.applicant') }}</p>
            </v-flex>

            <v-flex>
              <p
                class="text-xs-center subheading"
                v-html="$t('message.instructions.applicant')"
              ></p>
            </v-flex>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md class="no-top-padding">
              <v-layout row wrap>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="dealerApplication.name"
                    maxlength="40"
                    :counter="40"
                    :label="$t('message.dealerName')"
                    @input="chkAndSetSaveEnabled()"
                    v-validate="'required'"
                    :error-messages="errors.collect('name')"
                    name="name"
                    data-vv-as=" "
                    validate-on-blur
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="dealerApplication.doingBusinessAs"
                    maxlength="40"
                    :counter="40"
                    :label="$t('message.dba')"
                    @input="chkAndSetSaveEnabled()"
                    v-validate="'required'"
                    :error-messages="errors.collect('doingBusinessAs')"
                    name="doingBusinessAs"
                    data-vv-as=" "
                    validate-on-blur
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-select
                    v-model="dealerApplication.natureOfBusiness"
                    :items="
                      this.$store.getters.getProgramConfig('typesOfBusiness')
                    "
                    :label="$t('message.typeOfBusiness')"
                    v-validate="'required'"
                    :error-messages="errors.collect('natureOfBusiness')"
                    name="natureOfBusiness"
                    data-vv-as=" "
                    validate-on-blur
                    required
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm6 md4>
                  <v-select
                    v-model="dealerApplication.organizationType"
                    :items="this.$store.getters.getOrgTypes"
                    :label="$t('message.organizationType')"
                    v-validate="'required'"
                    :error-messages="errors.collect('organizationType')"
                    name="organizationType"
                    data-vv-as=" "
                    validate-on-blur
                    required
                  ></v-select>
                  <transition name="slide-fade">
                    <v-select
                      v-if="dealerApplication.organizationType === 'LLC'"
                      v-model="dealerApplication.llcType"
                      :items="this.$store.getters.getLLCTypes"
                      :label="$t('message.llcType')"
                      :error-messages="errors.collect('llcType')"
                      name="llcType"
                      v-validate="llcRules"
                      data-vv-as=" "
                      validate-on-blur
                    ></v-select>
                  </transition>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-text-field
                    v-model="dealerApplication.federalTaxIdNumber"
                    maxlength="9"
                    :counter="9"
                    :mask="numberMask9"
                    type="tel"
                    :label="$t('message.taxID')"
                    validate-on-blur
                    v-validate="'required|length:9'"
                    :error-messages="errors.collect('federalTaxIdNumber')"
                    name="federalTaxIdNumber"
                    data-vv-as=" "
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md4 v-if="this.$store.getters.isTDComplete">
                  <v-container grid-list-md ma-0 pa-0>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-text-field
                          v-model="dealerApplication.yearsInBusiness"
                          maxlength="3"
                          type="number"
                          :mask="numberMask3"
                          :label="$t('message.yearsBusiness')"
                          v-validate="yearsInBusinessRules"
                          :error-messages="errors.collect('yearsInBusiness')"
                          name="yearsInBusiness"
                          data-vv-as=" "
                          validate-on-blur
                          required
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-text-field
                          v-model="dealerApplication.monthsInBusiness"
                          maxlength="2"
                          type="number"
                          :mask="numberMask2"
                          :label="$t('message.monthsBusiness')"
                          v-validate="monthsInBusinessRules"
                          :error-messages="errors.collect('monthsInBusiness')"
                          hint="If you have been in business for less than a month, please enter 1 month"
                          persistent-hint
                          name="monthsInBusiness"
                          data-vv-as=" "
                          validate-on-blur
                          required
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>

                <v-flex xs8>
                  <v-text-field
                    v-model="dealerApplication.addressStreet"
                    maxlength="80"
                    :counter="80"
                    :label="$t('message.streetAddress')"
                    validate-on-blur
                    v-validate="'required'"
                    :error-messages="errors.collect('addressStreet')"
                    name="addressStreet"
                    data-vv-as=" "
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs4 v-if="this.$store.getters.isGafcoSelected">
                  <v-text-field
                    v-model="dealerApplication.storeIpAddress"
                    v-validate="'ip'"
                    prepend-icon="place"
                    @click:prepend="showIpAddressHelp"
                    maxlength="40"
                    :counter="40"
                    :label="$t('message.storeIpAddress')"
                    validate-on-blur
                    :error-messages="errors.collect('storeIpAddress')"
                    name="storeIpAddress"
                    data-vv-as=" "
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="dealerApplication.addressCity"
                    :label="$t('message.city')"
                    maxlength="40"
                    :counter="40"
                    v-validate="'required'"
                    :error-messages="errors.collect('addressCity')"
                    name="addressCity"
                    data-vv-as=" "
                    validate-on-blur
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 sm2>
                  <v-text-field
                    v-model="dealerApplication.addressState"
                    :mask="stateMask"
                    :label="$t('message.state')"
                    validate-on-blur
                    v-validate="'required|length:2|valid_us_state|valid_lender_state'"
                    :error-messages="errors.collect('addressState')"
                    name="addressState"
                    data-vv-as=" "
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs8 sm4>
                  <v-text-field
                    v-model="dealerApplication.addressZipCode"
                    :mask="zipMask"
                    :label="$t('message.zipCode')"
                    validate-on-blur
                    type="tel"
                    v-validate="'required|min:5'"
                    :error-messages="errors.collect('addressZipCode')"
                    name="addressZipCode"
                    data-vv-as=" "
                    required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="dealerApplication.emailAddress"
                    :label="$t('message.email')"
                    maxlength="60"
                    :counter="60"
                    type="email"
                    v-validate="'required|email'"
                    :error-messages="errors.collect('emailAddress')"
                    name="emailAddress"
                    data-vv-as=" "
                    validate-on-blur
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field
                    v-model="dealerApplication.phoneNumber"
                    :label="$t('message.businessPhoneNumber')"
                    :mask="phoneMask"
                    validate-on-blur
                    type="tel"
                    v-validate="'required|min:10'"
                    :error-messages="errors.collect('phoneNumber')"
                    name="phoneNumber"
                    data-vv-as=" "
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field
                    v-model="dealerApplication.faxNumber"
                    :label="$t('message.faxNumber')"
                    :mask="phoneMask"
                    validate-on-blur
                    type="tel"
                    v-validate="'min:10'"
                    :error-messages="errors.collect('faxNumber')"
                    name="faxNumber"
                    data-vv-as=" "
                  ></v-text-field>
                </v-flex>

                <v-flex xs4 v-if="this.$store.getters.isTDComplete">
                  <v-currency-field
                    v-bind="currencyConfig"
                    v-model="dealerApplication.annualSalesAmount"
                    validate-on-blur
                    v-validate="'required|min_value:1'"
                    :label="$t('message.annualSalesAmount')"
                    :error-messages="errors.collect('annualSalesAmount')"
                    name="annualSalesAmount"
                    data-vv-as=" "
                  ></v-currency-field>
                </v-flex>

                <v-flex xs4 v-if="this.$store.getters.isTDComplete">
                  <v-currency-field
                    v-bind="currencyConfig"
                    v-model="dealerApplication.annualFinancingAmount"
                    validate-on-change
                    v-validate="'required|min_value:1'"
                    :label="$t('message.annualFinancingAmount')"
                    :error-messages="errors.collect('annualFinancingAmount')"
                    name="annualFinancingAmount"
                    data-vv-as=" "
                  ></v-currency-field>
                </v-flex>

                <v-flex xs4 v-if="!this.$store.getters.isTDRCS">
                  <v-currency-field
                    v-bind="currencyConfig"
                    v-model="dealerApplication.avgTicketAmount"
                    validate-on-blur
                    v-validate="'required|min_value:1'"
                    :label="$t('message.avgTicketAmount')"
                    :error-messages="errors.collect('avgTicketAmount')"
                    name="avgTicketAmount"
                    data-vv-as=" "
                  ></v-currency-field>
                </v-flex>

                <v-flex xs4>
                  <v-text-field
                    v-model="dealerApplication.numberOfLocations"
                    :label="$t('message.numberOfLocations')"
                    validate-on-blur
                    type="tel"
                    v-validate="'required|min_value:1'"
                    :mask="numberMask5"
                    :error-messages="errors.collect('numberOfLocations')"
                    name="numberOfLocations"
                    data-vv-as=" "
                  ></v-text-field>
                </v-flex>

                <v-flex xs4>
                  <v-text-field v-if="this.$store.getters.isAvb"
                    v-model="dealerApplication.avbMarketingId"
                    :label="$t('message.avbMarketingId')"
                    validate-on-blur
                    v-validate="'required'"
                    :error-messages="errors.collect('avbMarketingId')"
                    name="avbMarketingId"
                    data-vv-as=" "
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <p>{{ $t('message.questions.website') }}</p>
                  <toggle-button
                    :sync="true"
                    v-model="dealerApplication.website"
                    :labels="{ checked: 'Yes', unchecked: 'No' }"
                  />
                </v-flex>
                <transition name="slide-fade">
                  <v-flex xs12 v-show="dealerApplication.website == true">
                    <v-text-field
                      v-model="dealerApplication.websiteUrl"
                      maxlength="40"
                      :counter="40"
                      type="url"
                      v-validate="websiteUrlRules"
                      :error-messages="errors.collect('websiteUrl')"
                      name="websiteUrl"
                      data-vv-as=" "
                      :label="$t('message.dealerWebsite')"
                      required
                    ></v-text-field>
                  </v-flex>
                </transition>

                <v-flex xs12>
                  <p>{{ $t('message.questions.tdMerchantNumber') }}</p>
                  <toggle-button
                    :sync="true"
                    v-model="dealerApplication.activeTdrcsDealer"
                    :labels="{ checked: 'Yes', unchecked: 'No' }"
                  />
                </v-flex>
                <transition name="slide-fade">
                  <v-flex xs12 v-show="dealerApplication.activeTdrcsDealer == true">
                    <v-text-field
                      v-model="dealerApplication.activeTdrcsDealerNumber"
                      maxlength="6"
                      :mask="numberMask6"
                      type="tel"
                      v-validate="'length:6'"
                      :error-messages="errors.collect('activeTdrcsDealer')"
                      name="activeTdrcsDealer"
                      data-vv-as=" "
                      :label="$t('message.tdMerchantNumber')"
                      required
                    ></v-text-field>
                  </v-flex>
                </transition>

                <v-flex xs12 v-if="this.$store.getters.isAvb">
                  <p>{{ $t('message.questions.avbHostedWebsite') }}</p>
                  <toggle-button
                    :sync="true"
                    v-model="dealerApplication.avbHostedWebsite"
                    row
                    :labels="{ checked: 'Yes', unchecked: 'No' }"
                  />
                </v-flex>

                <v-flex xs12 v-if="this.$store.getters.isAvb">
                  <p>{{ $t('message.questions.offerApplyAndBuy') }}</p>
                  <toggle-button
                    :sync="true"
                    v-model="dealerApplication.offerApplyAndBuy"
                    row
                    :labels="{ checked: 'Yes', unchecked: 'No' }"
                  />
                </v-flex>

                <v-flex xs12 v-if="this.$store.getters.isAvb">
                  <p>{{ $t('message.questions.wantOnlineCreditAppLink') }}</p>
                  <toggle-button
                    :sync="true"
                    v-model="dealerApplication.wantOnlineCreditAppLink"
                    row
                    :labels="{ checked: 'Yes', unchecked: 'No' }"
                  />
                </v-flex>

                <v-layout
                  row
                  wrap
                  v-show="availableLenders.length > 1"
                >
                  <v-flex xs12>
                    <v-divider style="margin-top: 20px;"></v-divider>
                  </v-flex>
                </v-layout>

                <v-layout row wrap
                  v-show="programHasReferrers()"
                >
                  <v-flex xs12>
                    <v-divider style="margin-top: 20px;"></v-divider>
                  </v-flex>

                  <v-flex xs12 row wrap style="justify-content: center !important;">
                    <h3 class="text-xs-center dealer-app-sub">
                      {{this.$store.getters.getProgramConfig('referrerLabel') }}
                    </h3>

                  </v-flex>

                  <v-flex xs8 offset-xs2 row wrap style="justify-content: center !important;">
                    <p class="text-xs-center subheading">
                      {{this.$store.getters.getProgramConfig('referrerLabelHelp') }}
                    </p>

                  </v-flex>

                  <v-flex xs12 row wrap style="justify-content: center !important;">
                    <p v-show="!selectedReferrersValid()"
                      class="text-xs-center subheading red--text"
                    >
                      At least one selection is required
                    </p>
                  </v-flex>

                  <v-flex xs12>
                    <!-- Partnership referrers-->
                    <v-layout row wrap class="lender-row">
                      <v-flex v-for="(referrer,index) in applicationReferrers"
                              xs12 :sm6="!singleColReferrers()" :lg3="!singleColReferrers()"
                        :key="index"
                      >
                        <input type="checkbox" v-model="applicationReferrers[index].selected"
                               :id="index" :value="referrer">
                        {{ referrer.name }}

                        <v-flex xs6 v-show="$store.getters.isUsingDealerNumber && referrer.hasDealerNumber">
                          <v-text-field
                            v-model="applicationReferrers[index].dealerNumber"
                            :disabled="!applicationReferrers[index].selected"
                            maxlength="40"
                            :label="'What is your ' + referrer.name + ' dealer number?'"
                          ></v-text-field>
                        </v-flex>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>


                <v-layout row wrap
                          v-if="this.$store.getters.isTCFRequired"
                >
                  <v-flex xs12>
                    <v-divider style="margin-top: 20px;"></v-divider>
                  </v-flex>

                  <v-flex xs12>
                    <p class="text-xs-center subheading">{{ $t('message.tcf.inventoryFinance') }}</p>
                  </v-flex>

                  <span
                    v-html="$t('message.tcf.legalText', [this.$store.getters.getDealerApplication.name])"
                  ></span>

                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="dealerApplication.tcfMerchantNumber"
                      :label="$t('message.tcf.merchantNumber')"
                      type="tel"
                      :mask="numberMask17"
                      v-validate="'required'"
                      :error-messages="errors.collect('tcfMerchantNumber')"
                      name="tcfMerchantNumber"
                      data-vv-as=" "
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field
                      v-model="dealerApplication.tcfAuthorizedSignature"
                      :label="$t('message.tcf.authorizedSignature')"
                      v-validate="'required'"
                      :error-messages="errors.collect('tcfSignature')"
                      name="tcfSignature"
                      data-vv-as=" "
                    ></v-text-field>
                  </v-flex>

                </v-layout>

              </v-layout>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat class="btn-secondary" @click.native="cancelEdit">
              {{ $t('message.cancel') }}
            </v-btn>

            <v-tooltip top>
              <v-btn
                flat
                slot="activator"
                class="btn-primary mx-1"
                @click="updateApp"
                :disabled="saveDisabled"
                >{{ $t('message.save') }}</v-btn
              >
              <span>{{ $t('message.saveAndResume') }}</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>

        <loading-modal></loading-modal>
      </v-dialog>
    </v-layout>

    <applicant-view/>

    <!-- we don't want this showing up in Finalize.vue-->
    <v-layout
      row
      wrap
      v-show="availableLenders.length > 1"
    >
      <v-flex xs12>
        <v-divider style="margin-top: 20px;"></v-divider>
      </v-flex>

      <v-flex xs3 row>
        <router-link
          class="btn-primary v-btn"
          :to="{
            name: 'lender-selection'
          }"
        >change providers</router-link>
      </v-flex>

      <v-flex xs9>
        <v-layout v-for="lender in dealerApplication.lenders" :key="lender.bankId" row wrap>
          <v-flex xs5>
            <div :class="lender.lenderTier+'-tier'" class="white--text pa-2 text-xs-center lender-selected">
              {{lender.name}}
            </div>
          </v-flex>
        </v-layout>
      </v-flex>

    </v-layout>


    <v-dialog
      v-model="ipAddressModal"
      max-width="500px"
    >
      <v-card>
        <v-card-title>
           <h3>Finding your store IP address</h3>
        </v-card-title>
        <v-card-text>
          Consult with your technical staff for your store's IP address. The value will include 4 groups of 1 to 3 digit numbers as follows:
                 <v-flex my-2>nnn.nnn.nnn.nnn</v-flex>
          <v-flex my-1>
            If you are currently located at your store, you may also determine your IP address by navigating to
            <a
              target="_blank"
              href="https://www.whatismyip.com"
            >www.whatismyip.com</a>.
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import { axiosAuthInstance } from '../../main.js'
import axiosMixin from '@/mixins/axiosMethods'
import LoadingModal from '../util/LoadingModal'
import ApplicantView from './ApplicantView'
import { APP_STATUSES } from '../../main.js'
import applicantMixins from '@/mixins/applicantMixins'

export default {
  data: () => ({
    ipAddressModal: false,
    dialog: false,
    valid: true,
    upload: false,
    dealerApplication: {appMetadata : {}},
    saveDisabled: false
  }),
  mixins: [axiosMixin,applicantMixins],
  props: ['unsavedChanges'],
  computed: {
    applicationReferrers() {
      return this.$store.getters.getDealerApplicationReferrers
    },
    availableLenders() {
      return this.$store.getters.getAvailableLenders
    },
    yearsInBusinessRules() {
      return 'required|min_value:0|max_value:500'
    },
    monthsInBusinessRules() {
      if (this.dealerApplication.yearsInBusiness == 0) {
        return 'required|min_value:1|max_value:11'
      } else {
        return 'required|min_value:0|max_value:11'
      }
    },
    websiteUrlRules() {
      return this.dealerApplication.website == true ? 'required|url' : ''
    },
    bankruptcyRules() {
      return this.dealerApplication.bankruptcyFiled == true ? 'required' : ''
    },
    priorApplicationHistoryRules() {
      return this.dealerApplication.priorApplicationHistory == true
        ? 'required'
        : ''
    },
    defendantLegalActionRules() {
      return this.dealerApplication.defendantLegalAction == true
        ? 'required'
        : ''
    },
    unpaidTaxesRules() {
      return this.dealerApplication.unpaidTaxes == true ? 'required' : ''
    },
    llcRules() {
      return this.dealerApplication.organizationType  === 'LLC' ? 'required' : ''
    }
  },
  methods: {
    showIpAddressHelp() {
      this.ipAddressModal = true
    },
    chkAndSetSaveEnabled() {
      this.saveDisabled = !this.dealerApplication.name || !this.dealerApplication.doingBusinessAs
    },
    openEditDialog() {
      this.dealerApplication = Object.assign(
        {},
        this.$store.getters.getDealerApplication
      )
      this.dialog = true;
    },
    cancelEdit() {
      this.buildDealerAppReferrers() //effectively cancels the referrer changes
      this.errors.clear()
      this.dialog = false
    },
    updateApp() {
      if (this.checkAndConfirmInvalidate()) {
        //Step 1 Validate Form
        //Stem 2 Gray out screen during load
        this.$store.commit('setLoading', true)

        this.dealerApplication.selectedReferrers = this.getSelectedReferrers()

        this.dealerApplication.status = APP_STATUSES.IN_PROGRESS
        axiosAuthInstance
          .post('api/v1/dealerApp/update', this.dealerApplication)
          .then(response => {
            this.$store.commit('setUnsavedData', false)
            this.$store.commit('setDealerApplication', response.data)
          })
          .catch(error => {
            this.notifyAxiosError(
              error,
              'There was an error updating the application'
            )
          })
          .then(() => {
            if (this.$store.getters.isApplicationJustInvalidated) {
              this.$store.commit('setApplicationJustInvalidated', false)
              this.$router.go() //reload to pick up all server side changes
            } else {
              this.$store.commit('setLoading', false)
              this.checkFormComplete()
            }
          })
      }


      this.dialog = false
    },
    setFormIconValidity(isValid) {
      this.$store.commit('setDealerInfoComplete', isValid)
    },
    checkFormComplete() {
      this.$validator
        .validateAll()
        .then(result => {
          if (result) {
            this.setFormIconValidity(this.selectedReferrersValid())
          } else {
            // console.log('Invalid Count:' + this.errors.count());
            // for (var i=0;i<this.errors.count();i++) {
            //   //note: if "field" here is null, you likely need to add a "name" attribute to the field with v-validate on it
            //   console.log('Invalid field: ' + this.errors.items[i].field);
            // }
            this.setFormIconValidity(false)
          }
        })
        .catch(e => {
          this.setFormIconValidity(false)
        })
    },
    getOrgTypes() {
      axiosAuthInstance
        .get('api/v1/dealerApp/orgtypes')
        .then(response => {
          var orgTypeEnums = response.data
          var orgTypes = []
          for (var i = 0; i < orgTypeEnums.length; i++) {
            orgTypes.push({
              value: orgTypeEnums[i],
              text: this.$t('message.orgTypeVals.' + orgTypeEnums[i])
            })
          }

          this.$store.commit('setOrgTypes', orgTypes)
        })
        .catch(error => {
          //we are hitting this when an invited owner registers from the invite email.... sometimes. Not sure why
          //but we don't need org types in that case, so just log this for now
          console.log('error:' + error)
          // this.notifyAxiosError(error, 'Failed to fetch Organization types');
        })
    },
    displayLenderList() {
      if (this.dealerApplication.lenders) {
        return this.dealerApplication.lenders.map(e => e.name).join('  -  ')
      }
    },
    getLLCTypes() {
      axiosAuthInstance
        .get('api/v1/dealerApp/llctypes')
        .then(response => {
          var llcTypeEnums = response.data
          var llcTypes = []
          for (var i = 0; i < llcTypeEnums.length; i++) {
            llcTypes.push({
              value: llcTypeEnums[i],
              text: this.$t('message.llcTypeVals.' + llcTypeEnums[i])
            })
          }

          this.$store.commit('setLLCTypes', llcTypes)
        })
        .catch(error => {
          //we are hitting this when an invited owner registers from the invite email.... sometimes. Not sure why
          //but we don't need org types in that case, so just log this for now
          console.log('error:' + error)
          // this.notifyAxiosError(error, 'Failed to fetch Organization types');
        })
    },
    //build a copy that includes all the programs referrers and has "selected" set appropriately
    buildDealerAppReferrers() {
      var applicationReferrers = []
      for (var p=0; p< this.$store.getters.getProgramReferrers.length; p++) {
        var pgmRef = this.$store.getters.getProgramReferrers[p]
        var appRef = null
        for (var a = 0; a < this.dealerApplication.selectedReferrers.length; a++) {
          if (this.dealerApplication.selectedReferrers[a].referrerId == pgmRef.id) {
            appRef = Object.assign({}, this.dealerApplication.selectedReferrers[a])
          }
        }
        if (appRef) {
          appRef.selected = true
        } else {
          appRef = Object.assign({}, this.$store.getters.getProgramReferrers[p])
          appRef.referrerId = appRef.id
          appRef.id = null
        }
        appRef.applicationId = this.dealerApplication.id
        appRef.name = pgmRef.name
        appRef.hasDealerNumber = pgmRef.hasDealerNumber

        applicationReferrers.push(appRef)
      }

      this.$store.commit('setDealerApplicationReferrers', applicationReferrers)
    },
    getApp() {
      this.$store.commit('setLoading', true)
      var applicationId = this.$store.getters.getApplicationId
      axiosAuthInstance
        .get('api/v1/dealerApp/get/' + applicationId)
        .then(response => {
          if (!response.data.lenders || response.data.lenders.length === 0)
          {
            this.$router.push('/lender-selection')
          }
          this.$store.commit('setDealerApplication', response.data)

          this.dealerApplication = Object.assign(
            {},
            this.$store.getters.getDealerApplication
          )

          this.buildDealerAppReferrers()

          this.fetchAvailableLenders(this.dealerApplication.exclusiveBankId)

          if (!this.dealerApplication.emailAddress) {
            this.dealerApplication.emailAddress = this.$store.getters.getAuthenticatedUser.email
          }

          if (this.$store.getters.isApplicationJustCreated) {
            this.$store.commit('setApplicationJustCreated', false)
            this.dialog = true
          }
        })
        .catch(error => {
          console.error(error)
          this.notifyAxiosError(
            error,
            'There was an error retrieving the application'
          )
        })
        .then(() => {
          this.checkFormComplete()
          this.$store.commit('setLoading', false)
        })
    }
  },
  created() {
    this.getOrgTypes()
    this.getLLCTypes()
    this.getApp()
  },
  components: {
    'loading-modal': LoadingModal,
    'applicant-view': ApplicantView
  }
}
</script>

<style lang="scss" scoped>
.btn-secondary {
  margin-right: 20px;
}
.lender-selected {
  border-radius: 8px;
}
.PRIME-tier {
  background-color: rgb(64,124,43);
}
.NEAR_PRIME-tier {
  background-color: rgb(137,191,69);
}
.LEASE-tier {
  background-color: rgb(96,0,157);
}
</style>



// WEBPACK FOOTER //
// src/components/Application/Applicant.vue